import React from "react";
import "./bluebutton.css";

function BlueButton({ text, onClick, styles, type = "button",disabled,loading }) {
  return (
    <button 
     className={`bluebtn ${loading ? "loading" : ""}`}
    type={type} onClick={onClick} style={styles}
    disabled={disabled}
    >
      {loading ? (
        <div className="bluebtn-spinner"></div>
      ) : (
        text
      )}
    </button>
  );
}

export default BlueButton;
